import { axios, handleError } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altCompanyLists = (data) => ({
  type: TYPES.ALT_COMPANY_LISTS,
  data,
})

export const getAllCompanies = (filter) => async (dispatch) => {
  try {
    const response = await axios.get(
      `/admin/companies/get_all${filter ? `?search=${filter}` : ''}`,
    )
    
    // Response structure: { status: "Companies fetched successfully", data: { companies: [...], pagination: {...} } }
    if (response && response.data) {
      // Transform snake_case API response to match frontend expectations
      const normalizedData = {
        data: response.data.companies.map(company => ({
          id: company.id,
          company_name: company.company_name,
          company_email: company.company_email,
          contact_person: `${company.contact_person_first} ${company.contact_person_last}`,
          contact_phone: company.contact_phone,
          business_address: company.business_address,
          business_type: company.business_type,
          status: company.status,
          created_at: company.created_at,
          updated_at: company.updated_at,
        })),
        pagination: response.data.pagination
      }
      
      dispatch(altCompanyLists(normalizedData))
      return normalizedData
    }
  } catch (error) {
    console.error('Error fetching companies:', error)
    handleError(error.response)
  }
}

export const createCompany = (data) => async (dispatch) => {
  try {
    // Split contact_person into first and last names
    const nameParts = data.contact_person ? data.contact_person.split(' ') : ['', '']
    const firstName = nameParts[0] || ''
    const lastName = nameParts.slice(1).join(' ') || ''

    const response = await axios.post('/admin/companies', {
      company_name: data.company_name,
      company_email: data.company_email,
      contact_person_first: firstName,
      contact_person_last: lastName,
      contact_phone: data.contact_phone,
      business_address: data.business_address,
      business_type: data.business_type || '',
      password: data.password,
    })
    
    if (response && response.data) {
      toast.success('Company account created successfully')
      await dispatch(getAllCompanies())
      return { status: 201 }
    }
  } catch (error) {
    console.error('Error creating company:', error)
    handleError(error.response)
    throw error
  }
}

export const getCompanyDetails = (companyId) => async (dispatch) => {
  try {
    const response = await axios.get(`/admin/companies/${companyId}`)
    
    // Response structure: { status: "Company fetched successfully", data: { ...company } }
    // After axios interceptor: response.data = { status: "...", data: {...company} }
    if (response && response.data) {
      const companyData = response.data;
      
      // Normalize the response to match frontend expectations
      const normalizedCompany = {
        id: companyData.id,
        company_name: companyData.company_name,
        company_email: companyData.company_email,
        contact_person: companyData.contact_person || `${companyData.contact_person_first || ''} ${companyData.contact_person_last || ''}`.trim(),
        contact_phone: companyData.contact_phone,
        business_address: companyData.business_address,
        business_type: companyData.business_type,
        status: companyData.status,
        created_at: companyData.created_at,
        updated_at: companyData.updated_at,
      }
      
      return { data: normalizedCompany }
    }
  } catch (error) {
    console.error('Error fetching company details:', error)
    handleError(error.response)
  }
}

export const updateCompany = (companyId, data) => async (dispatch) => {
  try {
    const response = await axios.put(`/admin/companies/${companyId}`, data)
    
    if (response && response.data) {
      toast.success('Company updated successfully')
      await dispatch(getAllCompanies())
      return response.data
    }
  } catch (error) {
    console.error('Error updating company:', error)
    handleError(error.response)
  }
}

export const deleteCompany = (companyId) => async (dispatch) => {
  try {
    const response = await axios.delete(`/admin/companies/${companyId}`)
    
    if (response && response.data) {
      toast.success('Company deleted successfully')
      await dispatch(getAllCompanies())
      return response.data
    }
  } catch (error) {
    console.error('Error deleting company:', error)
    handleError(error.response)
  }
}
